'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (length) {
  return (0, _withParams2.default)({ type: 'minLength', min: length }, function (value) {
    if (Array.isArray(value)) return value.length === 0 || value.length >= length;

    return value === undefined || value === null ? true : value === '' || String(value).length >= length;
  });
};